import { ReactElement } from 'react';
import { ThemeProvider, useTheme } from '@cbhq/cds-web';
import { coinbaseTheme } from '@cbhq/cds-web/themes/coinbaseTheme';

import { useClientProps } from '../providers/ClientPropsProvider';

type ThemeOverrideProps = { children: ReactElement };

export function ThemeOverride({ children }: ThemeOverrideProps) {
  const { standardized = true } = useClientProps();
  const { activeColorScheme } = useTheme();

  if (!standardized) {
    return children;
  }

  return (
    <ThemeProvider theme={coinbaseTheme} activeColorScheme={activeColorScheme} display="contents">
      {children}
    </ThemeProvider>
  );
}
